import JudgePoint from "@/types/judgePoint";
import { AggSubPanelResults } from "@/types/results.ts";

interface RhythmicAssessmentData {
  subPanelResults: {
    [group: string]: {
      judgePoints: {
        [judgeCode: string]: JudgePoint;
      };
      [key: string]: any;
    };
  };
  submitted?: boolean;
  [key: string]: any;
}

interface InitialAssessments {
  [judgeCode: string]: string | null;
}

const AssessmentService = {
  saveInitialAssessment(
    performanceId: string | number,
    judgeCode: string,
    value: string | number
  ): void {
    localStorage.setItem(`${performanceId}:${judgeCode}`, String(value));
  },

  saveAllInitialAssessmentsForRhythmicChiefJudge(
    performanceId: string,
    data: RhythmicAssessmentData
  ): void {
    Object.keys(data.subPanelResults).forEach((group) => {
      Object.keys(data.subPanelResults[group].judgePoints).forEach((judge) => {
        this.saveInitialAssessment(
          performanceId,
          judge,
          data.subPanelResults[group].judgePoints[judge].values.value
        );
      });
    });
  },

  saveAllInitialAssessmentsForAestheticChiefJudge(
    performanceId: string | number,
    data: AggSubPanelResults
  ): void {
    Object.keys(data.judgePoints).forEach((judge) => {
      this.saveInitialAssessment(performanceId, judge, data.judgePoints[judge].values.value);
    });
  },

  getInitialAssessment(performanceId: string, judgeCode: string): string | null {
    return localStorage.getItem(`${performanceId}:${judgeCode}`);
  },

  getAllInitialAssessmentsForPerformance(performanceId: number | string): InitialAssessments {
    let initialAssessments: InitialAssessments = {};
    Object.keys(localStorage).forEach((key) => {
      if (key.includes(performanceId + "")) {
        let keyData = key.split(":");
        initialAssessments[keyData[1]] = this.getInitialAssessment(keyData[0], keyData[1]);
      }
    });
    return initialAssessments;
  },

  clearAllInitialAssessmentsForPerformance(performanceId: string | number): void {
    Object.keys(localStorage).forEach((key) => {
      if (key.includes(performanceId + "")) {
        localStorage.removeItem(key);
      }
    });
  },
};

export default AssessmentService;
